import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
  type PayloadAction,
} from "@reduxjs/toolkit";
import {
  GetUserProfileThunk,
  // ChangePasswordThunk,
  PatchSitterProfile,
  // PatchMyProfileThunk,
  GetFullUserProfileThunk,
  GetWalletBalanceThunk,
  GetPetsThunk,
  UpdatePetThunk,
  UpdateAboutMeThunk,
  DeletePetThunk,
  GetPetByIdThunk,
  UpdateNotificationPreferenceThunk,
} from "./thunk";
import {
  clearAppSession,
  clearAppError,
} from "../../common/redux/globalActions";
import type {
  AccountSettings,
  ErrorsFromBackendType,
  Pet,
  UserProfileInterface,
} from "../ts";
import type { OnlineOfflineStatusEvent } from "../../conversations/ts";

const initialState: AccountSettings = {
  user_profile: null,
  reset_password: null,
  // is_loading: false,
  pets: [],
  pet: null,
  error: null,
  balance: undefined,
  // calendar_access: false,
  // calendar: undefined,
};

export const accountSettingsSlice = createSlice({
  name: "account_settings",
  initialState: initialState,
  reducers: {
    updateUserProfile(state, action) {
      state.user_profile = { ...state.user_profile, ...action.payload };
    },
    clearState: (state) => {
      state.user_profile = initialState.user_profile;
      state.reset_password = initialState.reset_password;
      state.error = initialState.error;
      state.balance = initialState.balance;
    },
    setStatus: (state, action: PayloadAction<OnlineOfflineStatusEvent>) => {
      state.user_profile =
        state.user_profile?.id === action.payload.profile_id
          ? { ...state.user_profile, is_online: action.payload.is_online }
          : state.user_profile;
    },
  },
  extraReducers: (builder) => {
    builder
      // Global Actions
      .addCase(clearAppSession, () => initialState)
      .addCase(clearAppError, (state, action) => {
        if (action.payload && state.error && action.payload in state.error) {
          delete state.error[action.payload];
        } else {
          state.error = null;
        }
      })
      // Feature Actions
      .addMatcher(
        isFulfilled(GetUserProfileThunk, GetFullUserProfileThunk),
        (state, action) => {
          state.user_profile = {
            ...action.payload,
          };
          // state.is_loading = false;
          state.error = null;
        },
      )
      // .addMatcher(isFulfilled(ChangePasswordThunk), (state, action) => {
      //   state.reset_password = action.payload.detail;
      //   // state.is_loading = false;
      //   state.error = null;
      // })
      .addMatcher(isFulfilled(PatchSitterProfile), (state) => {
        // state.is_loading = false.
        state.error = null;
      })
      .addMatcher(isFulfilled(UpdateAboutMeThunk), (state, action) => {
        // state.is_loading = false;
        state.user_profile = { ...state.user_profile, ...action.payload.data };
        state.error = null;
      })
      .addMatcher(
        isPending(
          GetUserProfileThunk,
          GetFullUserProfileThunk,
          // ResetPasswordThunk,
          PatchSitterProfile,
          UpdateAboutMeThunk,
          // CreatePetThunk,
          GetPetsThunk,
          UpdatePetThunk,
        ),
        (state) => {
          state.error = null;
          // state.is_loading = true;
        },
      )
      .addMatcher(
        isRejected(
          GetUserProfileThunk,
          GetFullUserProfileThunk,
          // ResetPasswordThunk,
          PatchSitterProfile,
          UpdateAboutMeThunk,
          // CreatePetThunk,
          GetPetsThunk,
          UpdatePetThunk,
        ),
        (state, action) => {
          state.error = action.payload as ErrorsFromBackendType;
          // state.is_loading = false;
        },
      )
      .addMatcher(isFulfilled(GetWalletBalanceThunk), (state, action) => {
        state.balance = action.payload.balance;
      })
      .addMatcher(isFulfilled(GetPetsThunk), (state, action) => {
        state.pets = action.payload.data;
      })
      .addMatcher(isFulfilled(GetPetByIdThunk), (state, action) => {
        state.pet = action.payload.data as Pet;
      })
      .addMatcher(isFulfilled(DeletePetThunk), (state, action) => {
        state.pets = state.pets.filter(
          (pet) => pet.id != action.meta.arg.pet_id,
        );
      })
      .addMatcher(
        isFulfilled(UpdateNotificationPreferenceThunk),
        (state, action) => {
          state.user_profile = {
            ...state.user_profile,
            surveys_and_interviews: action.meta.arg.surveys_and_interviews,
            tips_and_advice: action.meta.arg.tips_and_advice,
          } as UserProfileInterface;
        },
      );
  },
});

export const accountSettingsActions = accountSettingsSlice.actions;

export const { reducer: accountSettingReducer } = accountSettingsSlice;

export default accountSettingReducer;
